import { render, staticRenderFns } from "./list-appointments.vue?vue&type=template&id=64240426&"
import script from "./list-appointments.vue?vue&type=script&lang=js&"
export * from "./list-appointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports